module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/bestConversionIcon_UB.fa787ac4.svg";